"use client";

import { useEffect } from "react";
import { articlePath } from "@/utils/articlePath";

/**
 * When the article was opened with a legacy UUID in the path, replace the
 * visible URL with the slug (no navigation / no RSC refetch).
 */
export function ReplaceArticleUrlWithSlug({ slug }: { slug: string }) {
  useEffect(() => {
    const nextPath = articlePath(slug);
    const { pathname, search, hash } = window.location;
    if (pathname === nextPath) return;
    window.history.replaceState(null, "", `${nextPath}${search}${hash}`);
  }, [slug]);

  return null;
}
